import {  observable } from 'mobx';


export class TerraceDesignVM {
         @observable props;

         constructor(props: any = null) {
           this.props = props;
         }
       }
